/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestItemVisibility } from './RequestItemVisibility';
import {
    RequestItemVisibilityFromJSON,
    RequestItemVisibilityFromJSONTyped,
    RequestItemVisibilityToJSON,
    RequestItemVisibilityToJSONTyped,
} from './RequestItemVisibility';

/**
 * 
 * @export
 * @interface ChecklistTemplateItem
 */
export interface ChecklistTemplateItem {
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    instructions: string | null;
    /**
     * 
     */
    participant_reason: string | null;
    /**
     * 
     */
    item_group: string | null;
    /**
     * 
     */
    visibility: RequestItemVisibility;
    /**
     * 
     */
    sort_order: number;
}



/**
 * Check if a given object implements the ChecklistTemplateItem interface.
 */
export function instanceOfChecklistTemplateItem(value: object): value is ChecklistTemplateItem {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('instructions' in value) || value['instructions'] === undefined) return false;
    if (!('participant_reason' in value) || value['participant_reason'] === undefined) return false;
    if (!('item_group' in value) || value['item_group'] === undefined) return false;
    if (!('visibility' in value) || value['visibility'] === undefined) return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined) return false;
    return true;
}

export function ChecklistTemplateItemFromJSON(json: any): ChecklistTemplateItem {
    return ChecklistTemplateItemFromJSONTyped(json, false);
}

export function ChecklistTemplateItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChecklistTemplateItem {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'instructions': json['instructions'],
        'participant_reason': json['participant_reason'],
        'item_group': json['item_group'],
        'visibility': RequestItemVisibilityFromJSON(json['visibility']),
        'sort_order': json['sort_order'],
    };
}

export function ChecklistTemplateItemToJSON(json: any): ChecklistTemplateItem {
    return ChecklistTemplateItemToJSONTyped(json, false);
}

export function ChecklistTemplateItemToJSONTyped(value?: ChecklistTemplateItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'instructions': value['instructions'],
        'participant_reason': value['participant_reason'],
        'item_group': value['item_group'],
        'visibility': RequestItemVisibilityToJSON(value['visibility']),
        'sort_order': value['sort_order'],
    };
}

